import { Typography } from '@mui/material'
import { ReactNode, VFC } from 'react'
import { useAppointment } from '../../hooks'

const CustomerName: VFC = () => {
  const { appointment } = useAppointment()

  let name: ReactNode = <>&nbsp;</>

  if (appointment) {
    name = `${appointment?.customer?.givenName} ${appointment?.customer?.familyName}`
  }

  return (
    <Typography color="primary" variant="h2">
      {name}
    </Typography>
  )
}

export { CustomerName }
